import * as ex from "excalibur";
import { Resources } from "../../Resources";
import { Player } from "../../player";
import { Grandpa } from "../../actors/characters/grandpa";

import { goToScene } from "../../main";
import Kennedy from "../../actors/characters/kennedy";
import { inventoryState, playerState } from "../../state/stateManager";
import QuestionDialog from "../../ui/questionDialog";
import FurdlandCommerce from "../furdlandCommerce";
import Linda from "../../actors/characters/linda";
import OldMan from "../../actors/characters/oldMan";

export default class Furdland extends ex.Scene {
  constructor() {
    super();
    const player = new Player(18 * 16, 18 * 16);
    this.player = player;
    this.player.lastDir = "up";
    this.player.z = 2;
    this.player.wearingVeil = false;
    let notice = new ex.Actor({
      pos: new ex.Vector(20 * 16, 7 * 16),
      height: 24,
      width: 100,
      color: ex.Color.fromHex("#80530f"),
    });
    this.kennedy = new Kennedy({ x: 29 * 16, y: 6 * 16 });
    this.linda = new Linda({ x: 27 * 16, y: 8 * 16 }, "furdland");
  }
  onInitialize(engine) {
    Resources.FurdlandMap.addToScene(this);
    console.log("mccartys: adding player: ", this.player);
    this.engine.add("furdlandCommerce", FurdlandCommerce);
    this.player.lastDir = "up";
    // Resources.AppleCider.play(0.2);
    // Resources.AppleCider.loop = true;
    this.add(this.player);
    this.add(this.kennedy);
    // this.player = Resources.HouseMap.getObjectsByName("player");

    this.camera.zoom = 1;
    // const map_bounds = ex.BoundingBox.fromDimension(
    //   Resources.TownMap.map.width * Resources.TownMap.map.tilewidth + 10,
    //   Resources.TownMap.map.height * Resources.TownMap.map.tileheight + 10,
    //   ex.Vector.Zero,
    //   Resources.TownMap.pos
    // );
    // this.camera.strategy.limitCameraBounds(map_bounds);

    this.door = new ex.Trigger({
      pos: new ex.Vector(27 * 16, 17 * 16 + 8),
      width: 48,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("town", { x: 63 * 16, y: 20 * 16, direction: "down" });
      },
    });
    this.add(this.door);
    this.deskTrigger = new ex.Trigger({
      pos: new ex.Vector(29 * 16 + 8, 7 * 16 + 8),
      width: 96,
      height: 60,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        this.player.cutScene = true;
        this.interacting = true;
        this.kennedy.cutScene = true;
        this.greetingDialog = new QuestionDialog(
          ["Hi there, welcome to Furdland SuperMart. What Can I do for you?"],
          [`I'd like to sell honey.`, `Just browsing`],
          (reply, replyIndex) => {
            console.log("dialog ended");
            if (replyIndex == 0) {
              goToScene("furdlandCommerce");
            } else {
              this.interacting = false;
              this.player.cutScene = false;
              this.kennedy.cutScene = false;
            }
          },
          "kennedy",
          "bottom"
        );
      },
    });
    this.add(this.deskTrigger);
  }
  onActivate(data) {
    if (data.data) {
      console.log("have location data: ", data.data);
      this.player.pos = new ex.Vector(data.data.x, data.data.y);
    }

    this.player.cutScene = false;
    let content = playerState.getContent();
    if (content.npcLocations.linda.location == 1) {
      this.add(this.linda);
    }
    if (content.npcLocations.oldMan.location == 2) {
      if (this.oldMan == null || this.oldMan == undefined) {
        this.oldMan = new OldMan({ x: 17 * 16, y: 9 * 16 }, "furdland");
        this.oldMan.z = 3;
        this.add(this.oldMan);
      }
    }
  }
  onPostUpdate() {
    if (this.interacting) {
      if (this.engine.input.keyboard.wasPressed(ex.Keys.Up)) {
        this.greetingDialog.iterateReply(true);
      }
      if (this.engine.input.keyboard.wasPressed(ex.Keys.Down)) {
        this.greetingDialog.iterateReply(false);
      }
      if (this.engine.input.keyboard.wasPressed(ex.Keys.Enter)) {
        if (this.interacting) {
          this.greetingDialog.enterPress();
        }
      }
    }
  }
}
